import { useSelector } from "react-redux";
import { clubImportAccessSelector, creditAccessSelector, featureCostSelector, } from "./permissionsSelectors";
/**
 * Metered features. Returns the verdict plus the price, for CTA copy
 * ("Uses 1 credit") and for choosing which prompt to show on refusal.
 */
export const useCreditFeature = (featureId) => useSelector(creditAccessSelector(featureId));
/** Free features that read the user's imported club. No price, so no cost. */
export const useClubImportFeature = (featureId) => useSelector(clubImportAccessSelector(featureId));
/* Shorthands for plain show/hide and enable/disable. */
export const useCanUseCreditFeature = (featureId) => useSelector(creditAccessSelector(featureId)).allowed;
export const useCanUseClubImportFeature = (featureId) => useSelector(clubImportAccessSelector(featureId)).allowed;
/** Credits a call to this feature debits. */
export const useCreditFeatureCost = (featureId) => useSelector(featureCostSelector(featureId));
//# sourceMappingURL=useFeatureAccess.js.map